// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--exfsG","play-button":"a10a3f92e9--play-button--vPmrx","kinescope-player":"a10a3f92e9--kinescope-player--K3KBh"};